import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Person } from '../../../interfaces/person';
import { BehaviorSubject } from 'rxjs';
import { SEARCH_FOR_PERSON } from './graphql/person-search';

@Injectable({
  providedIn: 'root',
})
export class PersonSearchService {
  private _people: Person[] = [];
  private people = new BehaviorSubject(this._people);
  public people$ = this.people.asObservable();

  private _loading = false;
  private loading = new BehaviorSubject(this._loading);
  public loading$ = this.loading.asObservable();
  constructor(public apollo: Apollo) {}

  private setLoading(loading: boolean) {
    this._loading = loading;
    this.loading.next(this._loading);
  }

  public clearPeople() {
    this.setPeople([]);
  }
  private setPeople(people: Person[]) {
    this._people = people;
    this.people.next(this._people);
  }
  public searchForPerson(query: string | null, groupId: string | null) {
    if (query?.length && groupId?.length) {
      this.setLoading(true);
      this.apollo
        .query({
          query: SEARCH_FOR_PERSON,
          variables: { query, group_id: groupId },
        })
        .subscribe(({ data }) => {
          this.setLoading(false);
          if (data) this.setPeople(data.searchPeopleInGroup);
        });
    }
  }
}
